
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > components <
import SidebarLink from './SidebarLink.vue'
import SidebarCategory from './SidebarCategory.vue'

// > legacy/composable/useAccount <
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        SidebarLink,
        SidebarCategory,
    },
    props: {
        opened: {
            type: Boolean,
            default: true
        },
        environment: {
            type: String as PropType<'dev' | 'production'>,
            default: 'dev'
        }
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        const { havePermissions, haveRole } = useAccount()
        
        const toggle = () => emit('toggle', !props.opened)

        return {
            havePermissions,
            haveRole,
            toggle,
        }
    }
})
